/**
 * Le lot de la salle du live : la route `menu` sous son titre `live`.
 *
 * L'entrée vit en live (`livesInLive`) : c'est la seule route qui n'existe qu'en live. Elle est chargée à
 * son premier rendu (`loadedOnRender`), comme chaque écran inscrit. Sa garde (`tutorLiveRoomGuard`) la
 * rend à l'ancien écran dans une salle sans `events-panel`.
 */
import { loadedOnRender } from "../../student/loadedOnRender"
import { livesInLive } from "../../student/studentSpaceRouteTypes"
import { type TutorSpaceRouteName, type TutorSpaceRouteTable } from "../tutorSpaceRouteTypes"
import { tutorLiveRoomOpensOnDesignSystem } from "./tutorLiveRoomGuard"

export const roomRoutes: TutorSpaceRouteTable<"room"> = {
    // eslint-disable-next-line @typescript-eslint/no-require-imports
    menu: livesInLive(loadedOnRender(() => require("./TutorLiveScreen").TutorLiveScreen, "TutorLiveScreen")),
}

export const roomRouteGuards: Partial<Record<TutorSpaceRouteName, (state: unknown) => boolean>> = {
    menu: tutorLiveRoomOpensOnDesignSystem,
}
